import { mergeMap } from './mergeMap';
export function mergeMapTo(innerObservable, concurrent) {
    return mergeMap(function () { return innerObservable; }, concurrent);
}
//# sourceMappingURL=mergeMapTo.js.map